module.exports = __webpack_public_path__ + "img/milford-logo-icon.6b07ea0d.webp";